'use client';

import { Settings, Shield } from 'lucide-react'
import { useAppHost } from '@sourcepilot/ui/framework/state/AppHostContext'
import { iconMap } from '@sourcepilot/ui/framework/ui/atoms/icons'
import SidebarButton from '@sourcepilot/ui/shell/sidebar/SidebarButton';
import { useSimpleAuth } from '@sourcepilot/ui/shell/auth/use-simple-auth';

export function SimpleSidebar() {
  const { user } = useSimpleAuth();
  const isAdminMode = user?.admin_mode === true;
  const { sidebarItems } = useAppHost();

  const appsWithIcon = [];
  for (const app of sidebarItems) {
    const appWithIcon = {
      label: app.label,
      icon: iconMap[app.icon],
    }
    appsWithIcon.push(appWithIcon);
  }
  return (
    <div className="w-12 h-[calc(100vh-45px)] flex flex-col bg-gray-100 border-r border-gray-200">
      {/* Main icons */}
      <div className="flex flex-col items-center">
        {appsWithIcon.map((app) => (
          <SidebarButton
            key={app.label}
            appLabel={app.label}
          >
            <app.icon className="h-5 w-5" />
          </SidebarButton>
        ))}
      </div>

      {/* Admin button at bottom - only when admin mode is enabled */}
      <div className="mt-auto flex flex-col items-center">
        {isAdminMode && (
          <SidebarButton appLabel="Admin">
            <Shield className="h-5 w-5" />
          </SidebarButton>
        )}
        <button className="w-12 h-12 flex items-center justify-center hover:text-[#00ccaa]">
          <Settings className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
} 